<template>
  <v-container class="pa-1">
    <v-layout wrap
      ><v-flex class="py-2">
        <v-btn
          color="#FFD600"
          class="btnReport mt-1 ml-2"
          v-if="permission.report.order_receipt.food_delivery_receipt"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/order_report_food'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Order Food receipt report</span>
        </v-btn></v-flex
      ><v-flex class="py-2">
        <v-btn
          color="#FFD600"
          class="btnReport mt-1 ml-2"
          v-if="permission.report.order_receipt.free_delivery_receipt"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/order_report_free'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Order Free receipt report</span>
        </v-btn></v-flex
      ><v-flex class="py-2">
        <v-btn
          color="#FFD600"
          class="btnReport mt-1 ml-2"
          v-if="permission.report.order_receipt.messenger_receipt"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/order_report_messenger'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Order Messenger receipt report</span>
        </v-btn></v-flex
      ></v-layout
    >
  </v-container>
</template>

<style>
</style>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
  },
};
</script>
